import {Component, Input} from '@angular/core';

import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-dialog-view-tvan-using-register',
  templateUrl: './dialog-view-tvan-using-register.component.html'
})
export class DialogViewTvanUsingRegisterComponent {

  baseURL: string = environment.baseURL;

  @Input() display?: number;
  @Input() agreement: any;
  @Input() tVanLogs: Array<any> = new Array<any>();

  constructor() {
  }

  downloadXml(rowData: any): void {
    if (rowData && rowData.systemMessageId) {
      if (this.agreement.agreementId){
        window.open(`${this.baseURL}/iam-tvan/agrt-using-register/${rowData.systemMessageId}/xml`);
      }else if (this.agreement.taxWithholdCertId){
        window.open(`${this.baseURL}/iam-tax/cert-income-tax/${this.agreement.taxWithholdCertId}/tvan-log/${rowData.systemMessageId}/xml`);
      }
    }
  }

}
